export default class {

    mount() {
        const container = document.getElementById('disqus_thread')

        if (container) {
            // Set up observer
            const observer = new IntersectionObserver(this.handleInstersection.bind(this), {
                rootMargin: '300px 0px 300px 0px'
            })

            observer.observe(container)
        }
    }

    handleInstersection(entries, observer) {
        entries.forEach(entry => {
            const { target, isIntersecting } = entry

            if (isIntersecting) {
                this.loadScript()
                observer.unobserve(target)
            }
        })
    }

    loadScript() {
        const script = document.createElement('script')

        script.src = 'https://wrestlecrap.disqus.com/embed.js'
        script.setAttribute('data-timestamp', +new Date())

        document.body.appendChild(script)
    }

}
